/* Spark UX (sx-*) behaviours: reveal-on-scroll, counters, hero posters, announcement bar, rails, quick add, sticky bars. No dependencies. */
(function () {
  var d = document, w = window, html = d.documentElement;
  var RM = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROOT = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  var AR = /^ar/i.test(html.lang || '');
  var IO = 'IntersectionObserver' in w;

  /* reveal + count-up */
  var seen = IO && new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { show(e.target); seen.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  function show(el) { el.classList.add('is-in'); if (el.hasAttribute('data-sx-count')) count(el); }
  function count(el) {
    var end = parseFloat(el.getAttribute('data-sx-count')) || 0, sfx = el.getAttribute('data-sx-suffix') || '', t0 = 0;
    if (RM) { el.textContent = end.toLocaleString('en-US') + sfx; return; }
    (function step(t) {
      t0 = t0 || t; var p = Math.min(1, (t - t0) / 1200);
      el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))).toLocaleString('en-US') + sfx;
      if (p < 1) requestAnimationFrame(step);
    })(performance.now());
  }
  function reveal(root) {
    root.querySelectorAll('[data-sx-reveal]:not(.is-in),[data-sx-count]:not(.is-in)').forEach(function (el) {
      if (!seen || el.getBoundingClientRect().top < w.innerHeight) show(el); else seen.observe(el);
    });
  }

  /* hero poster carousel */
  function hero(root) {
    if (root.__sx) return; root.__sx = 1;
    var track = root.querySelector('[data-sx-track]'); if (!track) return;
    var slides = track.children, n = slides.length, dots = root.querySelectorAll('[data-sx-dot]'), i = 0, hold = 0, st, ready = 0;
    var auto = (parseFloat(root.getAttribute('data-autoplay')) || 0) * 1000;
    /* load a slide's pictures just before it shows (skips pictures hidden at this screen size) */
    function warm(k, now) {
      var s = slides[(k + n) % n];
      if (s && (ready || now)) s.querySelectorAll('img[loading="lazy"]').forEach(function (img) { if (img.getClientRects().length) img.loading = 'eager'; });
    }
    function go(k) { i = (k + n) % n; warm(i, 1); track.scrollTo({ left: slides[i].offsetLeft, behavior: RM ? 'auto' : 'smooth' }); }
    function sync() {
      i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      for (var j = 0; j < n; j++) {
        if (j === i) slides[j].removeAttribute('inert'); else slides[j].setAttribute('inert', '');
        if (dots[j]) dots[j].setAttribute('aria-current', j === i ? 'true' : 'false');
      }
      var tone = slides[i] && /--(dark|green)\b/.exec(slides[i].className);
      root.setAttribute('data-tone', tone ? tone[1] : 'light');
      warm(i + 1); if (i) warm(i - 1);
    }
    track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(sync, 90); }, { passive: true });
    dots.forEach(function (b, j) {
      b.addEventListener('click', function () { hold = Date.now() + 9000; go(j); });
      b.addEventListener('pointerenter', function () { warm(j, 1); });
    });
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold = Infinity; });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hold = 0; });
    root.addEventListener('touchstart', function () { hold = Date.now() + 12000; }, { passive: true });
    root.addEventListener('wheel', function () { hold = Date.now() + 9000; }, { passive: true });
    root.addEventListener('focusin', function () { hold = Infinity; });
    root.addEventListener('focusout', function () { hold = 0; });
    var onload = function () { setTimeout(function () { ready = 1; warm(i + 1); }, 400); };
    if (d.readyState === 'complete') onload(); else w.addEventListener('load', onload);
    if (auto && n > 1 && !RM) setInterval(function () { if (!d.hidden && Date.now() > hold) go(i + 1); }, auto);
    root.__go = function (k) { hold = Date.now() + 20000; go(k); };
    sync();
  }

  /* announcement bar: one message at a time, changes on its own (pauses while hovered or focused) */
  function ann(root) {
    if (root.__sx) return; root.__sx = 1;
    var items = root.querySelectorAll('[data-sx-ann-item]'), n = items.length, view = root.querySelector('.sx-ann__view');
    if (n < 2 || !view) return;
    var i = 0, hold = 0, t, speed = Math.max(3, parseFloat(root.getAttribute('data-speed')) || 5) * 1000;
    function show(k, back, manual) {
      k = (k + n) % n;
      if (k !== i) {
        var a = items[i], b = items[k]; i = k;
        root.classList.toggle('sx-ann--back', !!back);
        view.setAttribute('aria-live', manual ? 'polite' : 'off');
        clearTimeout(a.__t); clearTimeout(b.__t);
        a.classList.remove('is-on', 'is-in'); a.classList.add('is-out'); a.setAttribute('aria-hidden', 'true'); a.setAttribute('inert', '');
        b.classList.remove('is-out'); b.classList.add('is-on', 'is-in'); b.removeAttribute('aria-hidden'); b.removeAttribute('inert');
        a.__t = setTimeout(function () { a.classList.remove('is-out'); }, 600);
        b.__t = setTimeout(function () { b.classList.remove('is-in'); }, 600);
      }
      loop();
    }
    function loop() { clearTimeout(t); t = setTimeout(function () { if (d.hidden || Date.now() < hold) loop(); else show(i + 1); }, speed); }
    function release() { hold = 0; loop(); }
    var prev = root.querySelector('[data-sx-ann-prev]'), next = root.querySelector('[data-sx-ann-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1, 1, 1); });
    if (next) next.addEventListener('click', function () { show(i + 1, 0, 1); });
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold = Infinity; });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') release(); });
    root.addEventListener('focusin', function () { hold = Infinity; });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) release(); });
    root.addEventListener('touchstart', function () { hold = Date.now() + 8000; }, { passive: true });
    root.__go = function (k) { hold = Date.now() + 20000; show(k, k < i, 1); };
    loop();
  }

  /* product rails: arrow buttons scroll by ~one view */
  function rail(root) {
    if (root.__sx) return; root.__sx = 1;
    var track = root.querySelector('[data-sx-track]'); if (!track) return;
    root.querySelectorAll('[data-sx-prev],[data-sx-next]').forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = b.hasAttribute('data-sx-next') ? 1 : -1;
        if (getComputedStyle(track).direction === 'rtl') dir = -dir;
        track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: RM ? 'auto' : 'smooth' });
      });
    });
  }

  /* sticky buy / checkout bar: visible while its target button is off-screen */
  function sticky(bar) {
    if (bar.__sx || !IO) return; bar.__sx = 1;
    var sel = bar.getAttribute('data-sx-sticky'), target = null;
    var io = new IntersectionObserver(function (es) { bar.classList.toggle('is-on', !es[0].isIntersecting); });
    function attach() { var t = d.querySelector(sel); if (t && t !== target) { io.disconnect(); target = t; io.observe(t); } }
    var btn = bar.querySelector('[data-sx-click]');
    if (btn) btn.addEventListener('click', function () {
      var t = d.querySelector(btn.getAttribute('data-sx-click'));
      if (!t) return;
      if (t.disabled) t.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' }); else t.click();
    });
    function update() {
      attach();
      bar.querySelectorAll('[data-sx-mirror]').forEach(function (m) {
        var s = d.querySelector(m.getAttribute('data-sx-mirror'));
        if (s && s.textContent.trim()) m.textContent = s.textContent.trim();
      });
      if (btn) { var t = d.querySelector(btn.getAttribute('data-sx-click')); if (t) btn.classList.toggle('is-disabled', !!t.disabled); }
    }
    var scope = d.querySelector(bar.getAttribute('data-sx-scope')) || d.body, timer;
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(update, 60); }).observe(scope, { childList: true, subtree: true, characterData: true });
    update();
  }

  /* "read more" for long descriptions */
  function clamp(root) {
    root.querySelectorAll('[data-sx-clamp]').forEach(function (el) {
      el.classList.toggle('is-short', el.scrollHeight <= el.clientHeight + 24);
    });
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sx-more]'); if (!b) return;
    var box = d.getElementById(b.getAttribute('aria-controls')); if (!box) return;
    var open = box.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    b.textContent = b.getAttribute(open ? 'data-less' : 'data-more');
    if (!open) box.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
  });

  /* quick add from product cards (no page reload; works with the cart drawer or the cart page) */
  var tEl, tTimer;
  function toast(msg, link, err) {
    if (!tEl) { tEl = d.createElement('div'); tEl.className = 'sx-toast'; tEl.setAttribute('role', 'status'); tEl.setAttribute('aria-live', 'polite'); d.body.appendChild(tEl); }
    tEl.className = 'sx-toast' + (err ? ' sx-toast--err' : '');
    tEl.textContent = '';
    var s = d.createElement('span'); s.style.flex = '1'; s.textContent = msg; tEl.appendChild(s);
    if (link) {
      var a = d.createElement('a'), cd = d.querySelector('cart-drawer'); a.href = ROOT + 'cart'; a.textContent = AR ? 'عرض السلة' : 'View cart';
      if (cd && cd.open) a.addEventListener('click', function (e) { e.preventDefault(); tEl.classList.remove('is-on'); cd.open(d.getElementById('cart-icon-bubble')); });
      tEl.appendChild(a);
    }
    requestAnimationFrame(function () { tEl.classList.add('is-on'); });
    clearTimeout(tTimer); tTimer = setTimeout(function () { tEl.classList.remove('is-on'); }, 4500);
  }
  function bubble() {
    fetch(ROOT + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
      var el = d.getElementById('cart-icon-bubble'), h = j && j['cart-icon-bubble']; if (!el || !h) return;
      var t = d.createElement('div'); t.innerHTML = h; var s = t.querySelector('.shopify-section'); el.innerHTML = (s || t).innerHTML;
    }).catch(function () {});
  }
  /* themes using Dawn's cart drawer: swap in the fresh drawer so the cart icon opens the updated cart */
  function drawer(cd, secs) {
    try {
      var P = new DOMParser(), src = secs['cart-drawer'] && P.parseFromString(secs['cart-drawer'], 'text/html').getElementById('CartDrawer'), dst = d.getElementById('CartDrawer');
      if (!src || !dst) return false;
      dst.innerHTML = src.innerHTML;
      var ov = d.getElementById('CartDrawer-Overlay'); if (ov && cd.close) ov.addEventListener('click', cd.close.bind(cd));
      cd.classList.remove('is-empty');
      var bub = secs['cart-icon-bubble'] && P.parseFromString(secs['cart-icon-bubble'], 'text/html').querySelector('.shopify-section'), el = d.getElementById('cart-icon-bubble');
      if (bub && el) el.innerHTML = bub.innerHTML;
      return true;
    } catch (e) { return false; }
  }
  d.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('form[data-sx-add]')) return;
    e.preventDefault();
    var b = f.querySelector('button'), id = f.querySelector('[name="id"]');
    if (!b || !id) return;
    var cd = d.querySelector('cart-drawer'), body = { items: [{ id: +id.value, quantity: 1 }] };
    if (cd) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = w.location.pathname; }
    b.classList.add('is-loading');
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        b.classList.remove('is-loading'); b.classList.add('is-done'); setTimeout(function () { b.classList.remove('is-done'); }, 1600);
        if (!(cd && j && j.sections && drawer(cd, j.sections))) bubble();
        toast(AR ? 'تمت الإضافة إلى السلة ✓' : 'Added to your cart ✓', true);
      })
      .catch(function (err) { b.classList.remove('is-loading'); toast((err && (err.description || err.message)) || (AR ? 'تعذّرت الإضافة، حاول مرة أخرى' : 'Could not add — please try again'), false, true); });
  });

  function init(root) {
    root = root || d;
    root.querySelectorAll('[data-sx-hero]').forEach(hero);
    root.querySelectorAll('[data-sx-ann]').forEach(ann);
    root.querySelectorAll('[data-sx-rail]').forEach(rail);
    root.querySelectorAll('[data-sx-sticky]').forEach(sticky);
    clamp(root);
    reveal(root);
  }
  init(d);
  html.classList.add('sx-js');
  w.addEventListener('load', function () { clamp(d); });
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
  /* theme editor: show the slide or message being edited */
  d.addEventListener('shopify:block:select', function (e) {
    var el = e.target, box = el.closest && el.closest('[data-sx-hero],[data-sx-ann]');
    if (!box || !box.__go) return;
    var list = box.hasAttribute('data-sx-ann') ? box.querySelectorAll('[data-sx-ann-item]') : box.querySelector('[data-sx-track]').children;
    var k = [].indexOf.call(list, el); if (k > -1) box.__go(k);
  });
})();
